/**
 * The primary purpose to two fold here:
 *  - We want a quick way to discern between errors without string matches rather proto because speed
 *  - A fast way to quickly re-queue an event if a "recoverable" error occurs
 *
 * This is classified as recoverable for three attempts. This piece will not be in here immediately
 * but rather later.
 */
export class MissingFederatedModule extends Error {
  constructor(public module: string) {
    super(`[Analytics Module Init]: Module [${module}] was not found`);
    this.name = "MissingFederatedModule";
    this.module = module;
  }
}
